import styled from '@emotion/styled';
import { designTokens } from '@platform-ui/design-system';
import * as React from 'react';

import { useAIChatState } from '../../Concierge/useAIChatState';
import Footer from '../../Footer';
import { useMainPageScroll } from '../hooks/useMainPageScroll';
import { css } from '@emotion/react';

const FOOTER_HEIGHT = 56;

interface StyledLegalFooterProps {
  $hasScroll?: boolean;
  $leftPosition?: number;
  $isChatOpen?: boolean;
}

const StyledLegalFooter = styled.div<StyledLegalFooterProps>`
  ${(props) => {
    const hasScroll = props.$hasScroll ?? false;
    const leftPosition = props.$leftPosition ?? 0;

    if (!hasScroll) {
      return css`
        position: fixed;
        bottom: 0;
        left: ${leftPosition}px;
        right: 0;
      `;
    }

    return null;
  }}

  ${({ $isChatOpen, $hasScroll }) => {
    const aisdk = typeof window !== 'undefined' ? window.zAISDK : undefined;
    const isChatOpen = $isChatOpen ?? false;
    const hasScroll = $hasScroll ?? false;

    if (aisdk?.chatCardLayout && !hasScroll) {
      return css`
        right: ${isChatOpen
          ? aisdk.chatCardLayout.mainReserveRightPxWhenOpen
          : 0}px;
        transition: right ${aisdk.chatCardLayout.transitionDurationMs}ms
          ${aisdk.chatCardLayout.transitionEasing};
      `;
    }

    return null;
  }}


  & > div[data-e2e='nav-footer'] {
    width: 100%;
    height: ${FOOTER_HEIGHT}px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;
    color: ${designTokens.colors.lightEmphasisHigh};
    & > div:first-child {
      margin-bottom: 0;
      & > span {
        line-height: 1;
      }
    }
    & > div:last-child {
      flex-wrap: nowrap;
      gap: 0 32px;
      & > span {
        & > span {
          line-height: 1;
        }
        a {
          color: ${designTokens.colors.lightLink};
        }
      }
    }
  }
`;

export const LegalFooter = () => {
  const { isOpen: isChatOpen } = useAIChatState();
  const aisdk = typeof window !== 'undefined' ? window.zAISDK : undefined;

  const { hasScroll, leftPosition } = useMainPageScroll({
    scrollThreshold: FOOTER_HEIGHT,
  });

  return (
    <StyledLegalFooter
      $hasScroll={hasScroll}
      $leftPosition={leftPosition}
      $isChatOpen={Boolean(aisdk && isChatOpen)}
    >
      <Footer />
    </StyledLegalFooter>
  );
};

export default LegalFooter;
